/* Mirrors a product wholesale enquiry into the Arca trade platform as a tracked
   RFQ, in addition to Shopify's contact email. Deliberately non-blocking: if the
   API is unreachable the native form still submits, so an enquiry is never lost. */
(function () {
  var ENDPOINT = 'https://app.arcawholesale.com/api/rfqs';
  var form = document.getElementById('WholesaleEnquiryCheckout');
  if (!form) return;

  var params = new URLSearchParams(window.location.search);
  var handle = params.get('product');
  if (!handle) return; // General contact enquiries stay email-only.

  var product = null;
  fetch('/products/' + encodeURIComponent(handle) + '.js')
    .then(function (response) { return response.ok ? response.json() : null; })
    .then(function (data) { product = data; })
    .catch(function () { product = null; });

  var sent = false;
  form.addEventListener('submit', function () {
    if (sent) return;
    sent = true;

    var value = function (name) {
      var field = form.querySelector('[name="contact[' + name + ']"]');
      return field && field.value ? field.value.trim() : '';
    };

    var email = value('email');
    var destination = value('destination');
    if (!email || !destination) return; // The API would reject it; let the email carry it.

    var variantId = params.get('variant');
    var unit = 'case';
    if (product && product.variants && variantId) {
      for (var i = 0; i < product.variants.length; i += 1) {
        if (String(product.variants[i].id) === String(variantId)) { unit = product.variants[i].title || unit; break; }
      }
    }

    var notes = [
      'Company: ' + value('company'),
      'Contact: ' + value('name'),
      'Phone: ' + value('phone'),
      value('body')
    ].join('\n');

    var payload = {
      buyerEmail: email,
      destination: destination,
      notes: notes,
      lineItems: [{
        productHandle: handle,
        productTitle: (product && product.title) || handle,
        quantity: 1,
        unit: unit,
        notes: 'Submitted from the storefront enquiry form'
      }]
    };

    try {
      var blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      if (!(navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, blob))) {
        fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true,
          mode: 'cors'
        }).catch(function () {});
      }
    } catch (error) {
      /* Never block the native submission. */
    }
  });
})();
